import { RIGHT_ALIGNED } from 'common/constants';
import { ComposedTableDataType } from './types';
import type { ITooltipParams, ExcelStyle, GridApi } from 'ag-grid-community';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const tooltipGenerator = (params: ITooltipParams): any =>
  params?.value || '';

export const excelStyles: ExcelStyle[] = [
  {
    id: RIGHT_ALIGNED,
    alignment: {
      horizontal: 'Right'
    }
  }
];

export const filterRowData = <TData extends ComposedTableDataType>(
  gridApi: GridApi<TData>,
  isNestedTable: boolean | undefined
): { filteredRowCount: number; rowDataOfSearch: TData[] } => {
  let filteredRowCount = 0;
  const rowDataOfSearch: TData[] = [];
  gridApi.forEachNodeAfterFilter(node => {
    if (isNestedTable) {
      const rowNodeData =
        node.allLeafChildren[node.allLeafChildren.length - 1].data;
      if (node.id?.includes('row-group') && rowNodeData) {
        filteredRowCount += 1;
        rowDataOfSearch.push(rowNodeData);
      }
    } else filteredRowCount += 1;
  });
  return { filteredRowCount, rowDataOfSearch };
};
